<template>
  <NuxtParticles
    id="tsparticles"
    :options="particlesOptions"
    :fps-limit="60"
    :full-screen="true"
    @load="onLoad"
  />
</template>
<script setup lang="ts">
import { tsParticles } from 'tsparticles-engine';
import { loadConfettiPreset } from 'tsparticles-preset-confetti';
const particlesOptions = {
  preset: 'confetti',
  fullScreen: {
    enable: true,
    zIndex: 10,
  },
};
await loadConfettiPreset(tsParticles);
const onLoad = async (container) => {};
</script>
